import{e,m as t}from"./chunk-HBP5N4FR.js";var i,n=e(()=>{t();i=()=>Date.now()/1e3});export{i as a,n as b};
//# sourceMappingURL=chunk-WTIKHG7D.js.map
